// web/src/components/SyncBadge.jsx
// inline=true  → flows inside a flex header row (no fixed positioning)
// inline=false → fixed overlay (default, kept for any screen that needs it)
export default function SyncBadge({ isOnline, inline = false }) {
  const positionStyle = inline
    ? {}
    : { position: 'fixed', top: 8, right: 8, zIndex: 9999 };

  return (
    <div style={{
      ...positionStyle,
      display: 'flex', alignItems: 'center', gap: 6,
      background: '#2a2a2a', borderRadius: 20, padding: '4px 10px',
      border: `1px solid ${isOnline ? '#3dbd3d' : '#f59e0b'}`,
    }}>
      <div style={{
        width: 8, height: 8, borderRadius: '50%',
        backgroundColor: isOnline ? '#3dbd3d' : '#f59e0b',
        animation: isOnline ? 'none' : 'pulse 1.5s infinite',
      }} />
      <span style={{
        color: isOnline ? '#3dbd3d' : '#f59e0b',
        fontSize: 11, fontWeight: 700, letterSpacing: 1,
        fontFamily: "'Barlow Condensed', sans-serif",
      }}>
        {isOnline ? 'SYNCED' : 'OFFLINE'}
      </span>
      <style>{`@keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.3} }`}</style>
    </div>
  );
}
